import { firebaseUpload } from './firebase/firebaseStorage';

export function uploadFile(file, type) {
  return firebaseUpload(file, type);
}
